module.exports = __webpack_public_path__ + "img/one.399cf458.png";